import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PrivateHealthStepParams } from './types'
import { incomeSchema } from './types'

export const income = (params: PrivateHealthStepParams) => {
  const schema = incomeSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_privateHealth:steps.income.title',
        },
      },
      {
        type: 'choice',
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_privateHealth:steps.income.options.less_than_30k',
            },
            value: 'less_than_30k',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_privateHealth:steps.income.options.30k_to_50k',
            },
            value: '30k_to_50k',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_privateHealth:steps.income.options.50k_to_74k',
            },
            value: '50k_to_74k',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_privateHealth:steps.income.options.more_than_74k',
            },
            value: 'more_than_74k',
          },
        ],
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('income'),
      },
    ],
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('income'),
      valueToStepName: {
        less_than_30k: 'ineligible_status',
        '30k_to_50k': 'ineligible_status',
        '50k_to_74k': 'ineligible_status',
        more_than_74k: 'login',
      },
    },
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    subFlow: SubFlow.PrivateHealth,
  } as const satisfies AnyStepConfiguration
}
